<template>
  <el-dialog title="列配置"
             width="520px"
             :visible.sync="dialogVisible"
             :close-on-click-modal="false"
             append-to-body
             custom-class="table-column-config-dialog"
             @closed="onClosed">
    <p class="table-column-config-dialog__tip">拖拽调整列顺序，勾选控制列显示。保存后生效，取消则不修改。</p>

    <div class="table-column-config-dialog__body">
      <draggable v-model="sortableDraft"
                 tag="div"
                 handle=".table-column-config-dialog__drag-handle"
                 :animation="200"
                 ghost-class="table-column-config-dialog__item-ghost"
                 class="table-column-config-dialog__list">
        <div v-for="item in sortableDraft"
             :key="item.key"
             class="table-column-config-dialog__item">
          <i class="el-icon-rank table-column-config-dialog__drag-handle" />
          <el-checkbox v-model="item.visible"
                       :disabled="item.locked">
            {{ item.label }}
          </el-checkbox>
        </div>
      </draggable>

      <div v-if="lockedDraft.length"
           class="table-column-config-dialog__locked-list">
        <div v-for="item in lockedDraft"
             :key="item.key"
             class="table-column-config-dialog__item is-locked">
          <span class="table-column-config-dialog__drag-placeholder" />
          <el-checkbox v-model="item.visible"
                       disabled>
            {{ item.label }}
          </el-checkbox>
          <span class="table-column-config-dialog__locked-tag">固定</span>
        </div>
      </div>
    </div>

    <template slot="footer">
      <el-button @click="onReset">恢复默认</el-button>
      <el-button @click="onCancel">取消</el-button>
      <el-button type="primary"
                 @click="onSave">保存</el-button>
    </template>
  </el-dialog>
</template>

<script>
import draggable from 'vuedraggable'
import { buildDefaultColumnConfig } from '@core/utils/table-column-config'

export default {
  name: 'TableColumnConfigDialog',
  components: {
    draggable,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    appliedColumns: {
      type: Array,
      default: () => [],
    },
    definitions: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      sortableDraft: [],
      lockedDraft: [],
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (value) {
        this.$emit('update:visible', value)
      },
    },
    definitionMap () {
      const map = {}
      this.definitions.forEach(item => {
        map[item.key] = item
      })
      return map
    },
  },
  watch: {
    visible (value) {
      if (value) {
        this.initDraft()
      }
    },
  },
  methods: {
    initDraft () {
      const draft = this.buildDraftItems(this.appliedColumns)
      this.sortableDraft = draft.filter(item => !item.locked)
      this.lockedDraft = draft.filter(item => item.locked)
    },
    buildDraftItems (columns) {
      return columns.map(item => {
        const definition = this.definitionMap[item.key] || {}
        return {
          key: item.key,
          visible: definition.locked ? true : item.visible !== false,
          label: definition.label || item.key,
          locked: !!definition.locked,
        }
      })
    },
    getMergedDraft () {
      return [...this.sortableDraft, ...this.lockedDraft].map(item => ({
        key: item.key,
        visible: item.visible,
      }))
    },
    onReset () {
      const defaultConfig = buildDefaultColumnConfig(this.definitions)
      const draft = this.buildDraftItems(defaultConfig)
      this.sortableDraft = draft.filter(item => !item.locked)
      this.lockedDraft = draft.filter(item => item.locked)
    },
    onCancel () {
      this.dialogVisible = false
      this.$emit('cancel')
    },
    onSave () {
      const draft = this.getMergedDraft()
      const visibleCount = draft.filter(item => {
        const definition = this.definitionMap[item.key] || {}
        return item.visible && !definition.locked
      }).length

      if (visibleCount === 0) {
        this.$message.warning('请至少保留一列')
        return
      }

      this.$emit('save', draft)
      this.dialogVisible = false
    },
    onClosed () {
      this.sortableDraft = []
      this.lockedDraft = []
    },
  },
}
</script>

<style lang="scss" scoped>
.table-column-config-dialog__tip {
  margin: 0 0 12px;
  color: #909399;
  font-size: 13px;
  line-height: 1.6;
}

.table-column-config-dialog__body {
  max-height: 420px;
  overflow-y: auto;
  padding-right: 4px;
}

.table-column-config-dialog__list,
.table-column-config-dialog__locked-list {
  display: block;
}

.table-column-config-dialog__item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  margin-bottom: 8px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  background: #fafbfc;

  &.is-locked {
    background: #f5f7fa;
  }
}

.table-column-config-dialog__item-ghost {
  opacity: 0.6;
  background: #ecf5ff;
}

.table-column-config-dialog__locked-list {
  margin-top: 4px;
  padding-top: 8px;
  border-top: 1px dashed #ebeef5;
}

.table-column-config-dialog__drag-handle {
  color: #c0c4cc;
  cursor: move;
  font-size: 16px;
  flex-shrink: 0;
}

.table-column-config-dialog__drag-placeholder {
  width: 16px;
  flex-shrink: 0;
}

.table-column-config-dialog__locked-tag {
  margin-left: auto;
  color: #909399;
  font-size: 12px;
}
</style>

<style lang="scss">
.table-column-config-dialog {
  .el-dialog__body {
    padding-top: 12px;
    padding-bottom: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// core/components/TableColumnConfigDialog.vue